import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class KpiAccessGuard {
  constructor(
    private readonly _authService: AuthenticationService,
    private readonly _router: Router
  ) {}

  canActivate(): boolean {
    if (this._authService.hideKpis) {
      this._router.navigate(['/not-found']);
      return false;
    }
    return true;
  }
}
